import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState,  BaasicButton } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content, PageNavigation } from 'core/layouts';

function EmailTemplatesListTemplate({ emailTemplatesListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization
    } = emailTemplatesListViewStore;
    return (
        <ApplicationListLayout store={emailTemplatesListViewStore}>
            <PageNavigation>
                {false && (
                    <BaasicButton
                        className="btn btn--base btn--primary"
                        label="LIST_LAYOUT.CREATE_BUTTON"
                    />
                )}
            </PageNavigation>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} />
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='EMAIL_TEMPLATES.LIST.EMPTY_STATE.TITLE' description='EMAIL_TEMPLATES.LIST.EMPTY_STATE.DESCRIPTION' />
}

EmailTemplatesListTemplate.propTypes = {
    emailTemplatesListViewStore: PropTypes.object
};

export default defaultTemplate(EmailTemplatesListTemplate);
